/*
 * @Description: 
 * @Autor: wangwangwang
 * @Date: 2021-01-12 12:08:10
 * @LastEditors: 刘小二
 * @LastEditTime: 2023-01-18 09:51:40
 */
import request from '@/utils/request'
export const queryPage = '/icps/system/sign/intelligent/materials/product/queryPage'
export const smartqueryPage = '/icps/system/sign/intelligent/materials/prodectFormulation/queryPage'
export const batchSmartUpdateOrDelete = '/icps/system/sign/intelligent/materials/prodectFormulation/updateEnable'
export const specialQueryPage = '/icps/system/sign/intelligent/materials/specialMaterials/queryPage'
export const batchUpdateOrDelete = '/icps/system/sign/intelligent/materials/product/updateEnable'
export const specialBatchUpdateOrDelete = '/icps/system/sign/intelligent/materials/specialMaterials/updateRawProduct'
export const saveOrUpdate = '/icps/system/sign/intelligent/materials/product/saveOrUpdate'
/**特材罐-添加或修改 */
export function tanksaveOrUpdate(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/tank/saveOrUpdate',
    method: 'post',
    data
  })
}
/**特材罐-添加或修改 new */
export function tanksaveOrUpdateNew(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/tank/saveOrUpdateProductTank',
    method: 'post',
    data
  })
}
export function specialTanksaveOrUpdate(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/tank/saveOrUpdateSpecialTank',
    method: 'post',
    data
  })
}
/**分页查询特材罐*/
export function tankqueryPage(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/tank/queryPage',
    method: 'post',
    data
  })
}
export function specialTankqueryPage(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/tank/querySpecialTankPage',
    method: 'post',
    data
  })
}
export function tankqueryPageNew(params) {
  return request({
    url: '/icps/system/sign/intelligent/materials/tank/getSpecialTankList',
    method: 'get',
    params
  })
}
/**禁用，启用*/
export function updateRawProduct(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/specialMaterials/updateRawProduct',
    method: 'post',
    data
  })
}
/**删除*/
export function deleteRawProduct(params) {
  return request({
    url: '/icps/system/sign/intelligent/materials/specialMaterials/deleteRawProduct',
    method: 'get',
    params
  })
}
/**特材成品删除*/
export function deleteProduct(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/product/deleteProduct',
    method: 'post',
    data
  })
}
/**特材罐-删除*/
export function tankdelete(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/tank/delete',
    method: 'post',
    data
  })
}
export function specialTankdelete(data) {
  return request({
    url: '/system/sign/intelligent/materials/tank/deleteSpecialTank',
    method: 'post',
    data
  })
}
/**盘点或入库*/
export function tansaveOrUpdate(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/tank/saveOrUpdate',
    method: 'post',
    data
  })
}
/*每日盘点保存接口 */
export function inventoryProductTank(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/tank/inventoryProductTank',
    method: 'post',
    data
  })
}
/**盘点记录*/
export function recordsqueryPage(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/records/queryPage',
    method: 'post',
    data
  })
}
/**库存明细*/
export function queryInventoryDetailPage(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/specialMaterials/queryInventoryDetailPage',
    method: 'post',
    data
  })
}
/**新增价格设置*/
export function savMoney(data) {
  return request({
    url: '/icps/system/sign/materials/materialsMoney/savMoney',
    method: 'post',
    data
  })
}
/**获取价格设置列表*/
export function queryDataSource(data) {
  return request({
    url: '/icps/system/sign/materials/materialsMoney/queryPage',
    method: 'post',
    data
  })
}
/**删除*/
export function deleteMoney(data) {
  return request({
    url: '/icps/system/sign/materials/materialsMoney/deleteMoney',
    method: 'post',
    data
  })
}
/**查询原物料列表*/
export function queryRawList(data) {
  return request({
    url: '/icps/system/sign/basics/rawMaterials/QueryList',
    method: 'post',
    data
  })
}
/**添加原物料保存*/
export function saveRawProduct(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/specialMaterials/saveRawProduct',
    method: 'post',
    data
  })
}
/**配合比列表*/
export function queryMixtureRatioList(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/product/queryMixtureRatioList',
    method: 'post',
    data
  })
}
/**原物料来自特材原料中的改所属单位下的原物料*/
export function querySpecialList(params) {
  return request({
    url: '/icps/system/sign/intelligent/materials/specialMaterials/queryRawSpecialList',
    method: 'get',
    params
  })
}
/**添加配合比*/
export function saveMixtureRatio(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/product/saveMixtureRatio',
    method: 'post',
    data
  })
}
/**删除配合比*/
export function deleteMixtureRatio(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/product/deleteMixtureRatio',
    method: 'post',
    data
  })
}
/**库存明细列表数据*/
export function queryInventoryDetail(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/product/queryInventoryDetail',
    method: 'post',
    data
  })
}

/**特材复配 - (1)添加/修改特材成品时获取库存维护原料信息*/
export function smartConfigqueryRawList(params) {
  return request({
    url: '/icps/system/sign/intelligent/materials/prodectFormulation/queryRawList',
    method: 'get',
    params
  })
}

/**特材复配 - (2)添加/修改特材成品*/
export function smartSaveOrUpdate(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/prodectFormulation/saveOrUpdate',
    method: 'post',
    data
  })
}


/**特材复配 - (4)入库*/
export function productWarehousing(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/prodectFormulation/productWarehousing',
    method: 'post',
    data
  })
}

/**特材复配 - (5)入库明细列表*/
export function queryWarehousingRecord(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/prodectFormulation/queryWarehousingRecord',
    method: 'post',
    data
  })
}

/**特材复配 - 配合比列表*/
export function queryProductMix(params) {
  return request({
    url: '/icps/system/sign/intelligent/materials/prodectFormulation/queryProductMix',
    method: 'get',
    params
  })
}

/**特材复配 - 配合比原料列表*/
export function querySamrtMixtureRatioList(params) {
  return request({
    url: '/icps/system/sign/intelligent/materials/prodectFormulation/queryRawList',
    method: 'get',
    params
  })
}

/**特材复配 - (7)保存/修改配比设置*/
export function saveOrUpdateSmartMix(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/prodectFormulation/saveOrUpdateMix',
    method: 'post',
    data
  })
}

/* 每日盘点保存*/
export function specialTansaveOrUpdate(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/specialMaterials/inventoryRawStock',
    method: 'post',
    data
  })
}
